import MeetingRequestCFN from './MeetingRequestCFN'

export default MeetingRequestCFN
